// extracted by mini-css-extract-plugin
export default {"services":"Services_services__TJO8X","title":"Services_title__4dOxb","service-container":"Services_service-container__nSCCk","service-header":"Services_service-header__VA966"};